export default {
  namespaced: true,
  state: {
    connected: false,
    connecting: false,
    domain: null,
    reconnect: false,
  },

  mutations: {
    setDomain(state, domain) {
      state.domain = domain;
      state.reconnect = true;
    },

    setConnected(state, connected) {
      state.connected = connected;
    },
    setConnecting(state, connecting) {
      state.connecting = connecting;
    },
    setReconnect(state, reconnect) {
      state.reconnect = reconnect;
    },
    clear(state) {
      state.connected = false;
      state.connecting = false;
      state.instance = null;
      state.domain = null;
      state.reconnect = false;
    },
  },
};
